// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blog-sidebar>:not(:first-child){margin-top:3rem}.blog-sidebar h3{font-size:1.6rem}.blog-sidebar ul{padding:0;color:inherit;display:flex;flex-wrap:wrap}.blog-sidebar ul li{font-size:1.1rem;list-style:none;margin:1px}.blog-sidebar ul li a{color:inherit}.blog-sidebar ul li a:hover,.blog-sidebar ul li a:active{color:#1b232e;border-color:transparent;transition:border-color ease-in-out 0ms}\n", ""]);
// Exports
module.exports = exports;
